import { render, staticRenderFns } from "./BasicsExampleImage.vue?vue&type=template&id=477c3d92&scoped=true"
import script from "./BasicsExampleImage.vue?vue&type=script&lang=js"
export * from "./BasicsExampleImage.vue?vue&type=script&lang=js"
import style0 from "./BasicsExampleImage.vue?vue&type=style&index=0&id=477c3d92&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "477c3d92",
  null
  
)

export default component.exports